import { RequestPreviewDto, RequestDownloadExcelDto, RequestDownloadPdfDto, ResponseSendEmailExcelDto, ResponseSendEmailPdfDto } from './../dto/claim-report.dto';
import { NestApiProvider } from './../../nest-api';
import { Injectable } from '@angular/core';
import { RequestSendEmailExcelDto, RequestSendEmailPdfDto } from '../dto/claim-report.dto';
import {Observable} from "rxjs";

@Injectable()
export class ClaimReportApi {

    private service: string = '';
    private model: string = 'ClaimReport';
    private timeout: number = (5 * 60) * 1000;

    constructor(
        public nestApiProvider: NestApiProvider
    ) {

    }

    public preview(data: RequestPreviewDto) {
        const method: string = 'POST';
        const func: string = 'preview';
        const params: RequestPreviewDto = data;
        const urlParams: any = {};
        const body: any = {}

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<RequestPreviewDto>(method, url, params, urlParams, body, null, this.timeout);
    }

    public downloadExcel(data: RequestDownloadExcelDto){
        const method: string = 'POST';
        const func: string = 'downloadExcel';
        const params: RequestDownloadExcelDto = data;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    public downloadPdf(data: RequestDownloadPdfDto) {
        const method: string = 'POST';
        const func: string = 'downloadPdf';
        const params: RequestDownloadPdfDto = data;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    public reportSendEmailExcel(data: RequestSendEmailExcelDto): Observable<ResponseSendEmailExcelDto> {        const method: string = 'POST';
        const func: string = 'reportSendEmailExcel';
        const params: RequestSendEmailExcelDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseSendEmailExcelDto>(method, url, params, urlParams, body, null, this.timeout);
    }

    public reportSendEmailPdf(data: RequestSendEmailPdfDto): Observable<ResponseSendEmailPdfDto> {
        const method: string = 'POST';
        const func: string = 'reportSendEmailPdf';
        const params: RequestSendEmailPdfDto = data;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseSendEmailPdfDto>(method, url, params, urlParams, body, null, this.timeout);
    }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/claim-report.api.ts